module.exports = __webpack_public_path__ + "static/img/3.227a8f39.png";